import React from "react";
import { CopyMoveProps } from "./CopyMove.types";

const index = ({ text }: CopyMoveProps) => {
  return <>{text}</>;
};

export default index;
